export type WorkspaceSkeletonKind = "management" | "editor" | "list" | "files";

interface WorkspaceSkeletonProps {
  label: string;
  kind?: WorkspaceSkeletonKind;
}

/**
 * 所有异步一级页面共用的稳定骨架。
 * 骨架只描述布局，不伪造数据，避免各工作区加载时出现尺寸和文案风格跳变。
 */
export function WorkspaceSkeleton({ label, kind = "management" }: WorkspaceSkeletonProps) {
  return (
    <section
      className={`workspace-skeleton workspace-skeleton--${kind}`}
      role="status"
      aria-live="polite"
      aria-label={`正在载入${label}`}
    >
      <div className="workspace-skeleton-heading">
        <span className="workspace-skeleton-line workspace-skeleton-line--title" />
        <span className="workspace-skeleton-line workspace-skeleton-line--subtitle" />
      </div>
      <div className="workspace-skeleton-grid" aria-hidden="true">
        <span className="workspace-skeleton-card" />
        <span className="workspace-skeleton-card" />
        <span className="workspace-skeleton-card" />
      </div>
      <span className="sr-only">正在载入{label}…</span>
    </section>
  );
}
